import { useEffect, useRef, useState } from 'react';

// Returns true when a modal/drawer overlay is on screen. Modals in this app are
// full-screen `fixed inset-0` elements at z-index >= 40 (the tour sits at z-30).
// Used to hide the onboarding coach UI so it doesn't poke out beside an open
// panel. Detecting via the DOM (rather than threading every modal boolean)
// catches overlays owned by child components too (e.g. the MMR view, drawer).
// setState only fires on transitions, so it doesn't churn the caller each tick.
export function useOverlayOpen(active: boolean): boolean {
  const [open, setOpen] = useState(false);
  const last = useRef(false);

  useEffect(() => {
    if (!active) {
      if (last.current) { last.current = false; setOpen(false); }
      return;
    }
    const check = () => {
      const blocked = Array.from(document.querySelectorAll('div.fixed.inset-0')).some((el) => {
        const z = parseInt(window.getComputedStyle(el).zIndex || '0', 10);
        return z >= 40;
      });
      if (blocked !== last.current) { last.current = blocked; setOpen(blocked); }
    };
    check();
    const id = window.setInterval(check, 250);
    return () => window.clearInterval(id);
  }, [active]);

  return open;
}
